import { Domain } from '@repo/domain';
import { initAccessTokenManager } from './auth/accessTokenManager';
export class ParkAppRepository {
    config;
    constructor(config) {
        this.config = config;
        initAccessTokenManager(config);
    }
    capabilities = {
        [Domain.Availability]: async () => {
            return (ParkAppRepository.availabilityRepoPromise ??= import('./repositories/AvailabilityRepository').then((module) => {
                return new module.AvailabilityRepository(this.config);
            }));
        },
        [Domain.BankAccount]: async () => {
            return (ParkAppRepository.bankAccountRepoPromise ??= import('./repositories/BankAccountRepository').then((module) => {
                return new module.BankAccountRepository(this.config);
            }));
        },
        [Domain.Billing]: async () => {
            return (ParkAppRepository.billingRepoPromise ??= import('./repositories/BillingRepository').then((module) => {
                return new module.BillingRepository(this.config);
            }));
        },
        [Domain.Consent]: async () => {
            return (ParkAppRepository.consentRepoPromise ??= import('./repositories/ConsentRepository').then((module) => {
                return new module.ConsentRepository(this.config);
            }));
        },
        [Domain.OwnedParking]: async () => {
            return (ParkAppRepository.ownedParkingRepoPromise ??= import('./repositories/OwnedParkingRepository').then((module) => {
                return new module.OwnedParkingRepository(this.config);
            }));
        },
        [Domain.OwnedParkingImage]: async () => {
            return (ParkAppRepository.ownedParkingImageRepoPromise ??=
                import('./repositories/OwnedParkingImageRepository').then((module) => {
                    return new module.OwnedParkingImageRepository(this.config);
                }));
        },
        [Domain.OwnedParkingPriceRule]: async () => {
            return (ParkAppRepository.ownedParkingPriceRuleRepoPromise ??=
                import('./repositories/OwnedParkingPriceRuleRepository').then((module) => {
                    return new module.OwnedParkingPriceRuleRepository(this.config);
                }));
        },
        [Domain.OwnedParkingSpot]: async () => {
            return (ParkAppRepository.ownedParkingSpotRepoPromise ??=
                import('./repositories/OwnedParkingSpotRepository').then((module) => {
                    return new module.OwnedParkingSpotRepository(this.config);
                }));
        },
        [Domain.Parking]: async () => {
            return (ParkAppRepository.parkingRepoPromise ??= import('./repositories/ParkingRepository').then((module) => {
                return new module.ParkingRepository(this.config);
            }));
        },
        [Domain.ParkingExistenceAtLocation]: async () => {
            return (ParkAppRepository.parkingExistenceAtLocationRepoPromise ??=
                import('./repositories/ParkingExistenceAtLocationRepository').then((module) => {
                    return new module.ParkingExistenceAtLocationRepository(this.config);
                }));
        },
        [Domain.ParkingForRegistrationNumberCheck]: async () => {
            return (ParkAppRepository.parkingForRegistrationNumberCheckRepoPromise ??=
                import('./repositories/ParkingForRegistrationNumberCheckRepository').then((module) => {
                    return new module.ParkingForRegistrationNumberCheckRepository(this.config);
                }));
        },
        [Domain.ParkingPath]: async () => {
            return (ParkAppRepository.parkingPathRepoPromise ??= import('./repositories/ParkingPathRepository').then((module) => {
                return new module.ParkingPathRepository(this.config);
            }));
        },
        [Domain.ParkingVehicle]: async () => {
            return (ParkAppRepository.parkingVehicleRepoPromise ??= import('./repositories/ParkingVehicleRepository').then((module) => {
                return new module.ParkingVehicleRepository(this.config);
            }));
        },
        [Domain.ParkingValidation]: async () => {
            return (ParkAppRepository.parkingValidationRepoPromise ??=
                import('./repositories/ParkingValidationRepository').then((module) => {
                    return new module.ParkingValidationRepository(this.config);
                }));
        },
        [Domain.Pilot]: async () => {
            return (ParkAppRepository.pilotRepoPromise ??= import('./repositories/PilotRepository').then((module) => {
                return new module.PilotRepository(this.config);
            }));
        },
        [Domain.Price]: async () => {
            return (ParkAppRepository.priceRepoPromise ??= import('./repositories/PriceRepository').then((module) => {
                return new module.PriceRepository(this.config);
            }));
        },
        [Domain.User]: async () => {
            return (ParkAppRepository.userRepoPromise ??= import('./repositories/UserRepository').then((module) => {
                return new module.UserRepository(this.config);
            }));
        },
        [Domain.Payment]: async () => {
            return (ParkAppRepository.paymentRepoPromise ??= import('./repositories/PaymentRepository').then((module) => {
                return new module.PaymentRepository(this.config);
            }));
        },
        [Domain.PaynowClause]: async () => {
            return (ParkAppRepository.paynowClauseRepoPromise ??= import('./repositories/PaynowClauseRepository').then((module) => {
                return new module.PaynowClauseRepository(this.config);
            }));
        },
        [Domain.Reservation]: async () => {
            return (ParkAppRepository.reservationRepoPromise ??= import('./repositories/ReservationRepository').then((module) => {
                return new module.ReservationRepository(this.config);
            }));
        },
        [Domain.ReservationSpanPaymentLink]: async () => {
            return (ParkAppRepository.reservationSpanPaymentLinkRepoPromise ??=
                import('./repositories/ReservationSpanPaymentLinkRepository').then((module) => {
                    return new module.ReservationSpanPaymentLinkRepository(this.config);
                }));
        },
        [Domain.Sign]: async () => {
            return (ParkAppRepository.signRepoPromise ??= import('./repositories/SignRepository').then((module) => {
                return new module.SignRepository(this.config);
            }));
        },
        [Domain.Ticket]: async () => {
            return (ParkAppRepository.ticketRepoPromise ??= import('./repositories/TicketRepository').then((module) => {
                return new module.TicketRepository(this.config);
            }));
        },
        [Domain.UnauthorizedUseCase]: async () => {
            return (ParkAppRepository.unauthorizedUseCaseRepoPromise ??=
                import('./repositories/UnauthorizedUseCaseRepository').then((module) => {
                    return new module.UnauthorizedUseCaseRepository(this.config);
                }));
        },
        [Domain.Unavailability]: async () => {
            return (ParkAppRepository.unavailabilityRepoPromise ??= import('./repositories/UnavailabilityRepository').then((module) => {
                return new module.UnavailabilityRepository(this.config);
            }));
        },
        [Domain.UnavailabilityDay]: async () => {
            return (ParkAppRepository.unavailabilityDayRepoPromise ??=
                import('./repositories/UnavailabilityDayRepository').then((module) => {
                    return new module.UnavailabilityDayRepository(this.config);
                }));
        },
        [Domain.Vehicle]: async () => {
            return (ParkAppRepository.vehicleRepoPromise ??= import('./repositories/VehicleRepository').then((module) => {
                return new module.VehicleRepository(this.config);
            }));
        },
        [Domain.Wallet]: async () => {
            return (ParkAppRepository.walletRepoPromise ??= import('./repositories/WalletRepository').then((module) => {
                return new module.WalletRepository(this.config);
            }));
        },
    };
    static availabilityRepoPromise;
    static bankAccountRepoPromise;
    static billingRepoPromise;
    static consentRepoPromise;
    static ownedParkingImageRepoPromise;
    static ownedParkingPriceRuleRepoPromise;
    static ownedParkingRepoPromise;
    static ownedParkingSpotRepoPromise;
    static parkingRepoPromise;
    static parkingExistenceAtLocationRepoPromise;
    static parkingForRegistrationNumberCheckRepoPromise;
    static parkingPathRepoPromise;
    static parkingVehicleRepoPromise;
    static parkingValidationRepoPromise;
    static paymentRepoPromise;
    static paynowClauseRepoPromise;
    static pilotRepoPromise;
    static priceRepoPromise;
    static userRepoPromise;
    static reservationRepoPromise;
    static reservationSpanPaymentLinkRepoPromise;
    static signRepoPromise;
    static ticketRepoPromise;
    static unauthorizedUseCaseRepoPromise;
    static unavailabilityRepoPromise;
    static unavailabilityDayRepoPromise;
    static vehicleRepoPromise;
    static walletRepoPromise;
}
